import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from '../locales/en/pages.json'
import fi from '../locales/fi/pages.json'
import sv from '../locales/sv/pages.json'
import fr from '../locales/fr/pages.json'
import de from '../locales/de/pages.json'

const resources = {
  en: { pages: en },
  fi: { pages: fi },
  sv: { pages: sv },
  fr: { pages: fr },
  de: { pages: de },
}

// Single source of truth for supported languages — derived from the bundled
// locale resources, so adding a new language to `resources` is sufficient.
export type SupportedLanguage = keyof typeof resources

export const SUPPORTED_LANGUAGES = Object.keys(resources) as SupportedLanguage[]

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    // Detection order favours admin-ui's `preferredLanguage` localStorage
    // key (written by admin-ui's ProfilePage when the user changes their
    // profile language). control-ui has no language switcher — it follows
    // whatever admin-ui has set.
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'preferredLanguage',
      caches: ['localStorage'],
    },

    ns: ['pages'],
    defaultNS: 'pages',

    supportedLngs: SUPPORTED_LANGUAGES,

    react: {
      useSuspense: false,
    },

    resources,
  })

export default i18n
